var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccordionOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0ZM14 26.7273C6.97091 26.7273 1.27274 21.0291 1.27274 14C1.27274 6.97091 6.97091 1.27274 14 1.27274C21.0291 1.27274 26.7273 6.97091 26.7273 14C26.7273 21.0291 21.0291 26.7273 14 26.7273Z",
    fill: "#D6D6D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9497 10.1109C19.2436 9.81704 19.2436 9.34416 18.9497 9.05027C18.6559 8.75638 18.183 8.75638 17.8891 9.05027L14 12.9394L10.1109 9.05027C9.81702 8.75638 9.34414 8.75638 9.05025 9.05027C8.75636 9.34416 8.75636 9.81704 9.05025 10.1109L12.9393 14L9.05025 17.8891C8.75636 18.183 8.75636 18.6559 9.05025 18.9498C9.34414 19.2437 9.81702 19.2437 10.1109 18.9498L14 15.0607L17.8891 18.9498C18.183 19.2437 18.6559 19.2437 18.9497 18.9498C19.2436 18.6559 19.2436 18.183 18.9497 17.8891L15.0607 14L18.9497 10.1109Z",
    fill: "#01152E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordionOpen);
export default __webpack_public_path__ + "static/media/accordion-open.ce0a96b1fbfbe6e84ca08642e0c2e69e.svg";
export { ForwardRef as ReactComponent };